import {useDrag} from "react-dnd";

const User_SetRoleStat_RoleCard_Mini = (props) => {
    const [, drag] = useDrag(
        () => ({
            item: {
                name: props.role,
                type: "role" },
            collect: (monitor) => ({
                opacity: monitor.isDragging() ? 0 : 1
            })
        }),
        [props.role, "role" ]
    );
    let style = {}
    if(props.isLast){
        style = {
            paddingRight: '0px'
        }
    }
    return  <div className='user-set-role-state-user-card-roles' style={style}>
        <img alt={'icon'} ref={drag} src={props.roleBG} title={props.roleTooltip}/>
    </div>
}
export default User_SetRoleStat_RoleCard_Mini;
